import { render, staticRenderFns } from "./SettingLeavePolicy.vue?vue&type=template&id=72f98d1e&"
import script from "./SettingLeavePolicy.vue?vue&type=script&lang=js&"
export * from "./SettingLeavePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports